import React, { useState, useRef, useEffect } from "react";
import { CgProfile } from "react-icons/cg";
import {
  FaSignOutAlt,
  FaBars,
  FaChevronDown,
  FaListAlt,
  FaUserTie,
} from "react-icons/fa";
import { LuLayoutDashboard, LuPackage, LuUserCheck } from "react-icons/lu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoCloseSharp } from "react-icons/io5";

import useClickAway from "../../hooks/ui/useClickAway";
import { useDispatch, useSelector } from "react-redux";

import {
  resettowerHeadAdminProfile,
  settowerHeadAdminProfile,
} from "../../store/slice/globalStore";

import authManager from "../../utils/towerHeadAdmin/authManager";
import { getFileUrl } from "../../utils/helper";
import { Archive, Box, CopyPlusIcon, GalleryHorizontal } from "lucide-react";

import {
  CAFETERIA_INVENTORY_ROUTE,
  COMMON1,
  COMMON4,
  COMMON5,
  CREATE_ADMIN_ROUTE,
  DASHBOARD_ROUTE,
  EMP_ROUTES,
  EMP_USAGE_ROUTES,
  EXCEL_PRODUCT,
  GALLERY_ROUTE,
  LOGIN_ROUTE,
  MEALS_ROUTES,
  MENU_PRICE,
  PRODUCT_ROUTE,
  PROFILE_ROUTE,
  REVENUE_ROUTES,
  TOP_SELLING_ROUTES,
  VENDOR_COMPLIANCE_ROUTE,
  VENDOR_MANAGER_ROUTE,
  VENDOR_ROUTE,
} from "../../routes/towerHeadAdmin/towerHeadAdminRoutes";
import apiRequest from "../../utils/towerHeadAdmin/apiRequest";
import TowerAdminAuth from "../../middleware/TowerAdminAuth";


const Layout = ({ children }) => {
  const setting = useSelector((state) => state.globalState.siteSetting);
  const siteName = useSelector(
    (state) => state.globalState?.siteSetting?.site_settings?.site_name
  );

  const LOGO = getFileUrl(setting?.site_settings?.site_logo);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const towerHeadAdminProfile = useSelector((state) => state.globalState.towerHeadAdminProfile);
 
  

  useClickAway(dropdownRef, () => setIsDropdownOpen(false));

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  const toggleSubMenu = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const fetchAndSetVendorProfile = async () => {
    apiRequest
      .getProfile()
      .then((data) => {
        dispatch(settowerHeadAdminProfile(data?.data?.data));
      })
      .catch((error) => {
        authManager.deleteTowerHeadAdminAccessToken();
        dispatch(resettowerHeadAdminProfile(null));
       navigate(LOGIN_ROUTE);
      });
  };

  useEffect(()=>{
    fetchAndSetVendorProfile();
  },[!towerHeadAdminProfile])

  const handleLogout = async () => {
    authManager.deleteTowerHeadAdminAccessToken();
    dispatch(resettowerHeadAdminProfile(null));
    navigate(LOGIN_ROUTE);
  };




  return (
    <TowerAdminAuth>
      <div className="grid grid-cols-1 md:grid-cols-[250px_1fr] h-screen overflow-hidden bg-gray-50">
        <div
          className={`fixed md:static top-0 z-50 max-h-screen bg-white shadow-lg transition-all duration-300 ease-in-out flex flex-col h-full border-r border-gray-200 w-[250px] ${isMobileSidebarOpen ? "translate-x-0" : "-translate-x-full"
            } md:translate-x-0`}
        >
          <div className="flex items-center justify-between p-3 border-b border-gray-100">
            <div className="flex items-center h-[18px] space-x-2"></div>
            <button
              onClick={toggleMobileSidebar}
              className="text-gray-600 hover:text-gray-800 hover:bg-gray-100 p-1 rounded-md transition-all duration-200 focus:outline-none md:hidden"
            >
              <IoCloseSharp className="text-2xl" />
            </button>
          </div>

          <div className="flex-1 mt-[18px] md:mt-[25px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
            <MenuGroup
              label="Corporate Admin Head"
              activeMenu={activeMenu}
              toggleSubMenu={toggleSubMenu}
              menuItems={[
                {
                  label: "Home",
                  icon: <LuLayoutDashboard />,
                  link: DASHBOARD_ROUTE,
                },
                {
                  label: "Tower Admin",
                  icon: <LuUserCheck />,
                  link: CREATE_ADMIN_ROUTE,
                },

                {
                  label: "Menu & Pricing",
                  icon: <LuPackage />,
                  link: MENU_PRICE,
                },
                {
                  label: "Products",
                  icon: <LuPackage />,
                  link: EXCEL_PRODUCT,
                },
                {
                  label: "Cafeteria Inventory",
                  icon: <Box />,
                  link: CAFETERIA_INVENTORY_ROUTE,
                },
                {
                  label: "Vendors",
                  icon: <FaUserTie />,
                  subMenus: [
                    {
                      label: "Vendor",
                      link: VENDOR_ROUTE,
                    },
                    {
                      label: "Vendor Manager",
                      link: VENDOR_MANAGER_ROUTE,
                    },
                  ],
                },


                {
                  label: "Track Vendor compliances",
                  icon: <Archive />,
                  link: VENDOR_COMPLIANCE_ROUTE,
                },
                {
                  label: "Create Coupon",
                  icon: <CopyPlusIcon />,
                  link: COMMON5,
                },
                {
                  label: "Gallery",
                  icon: <GalleryHorizontal />,
                  link: GALLERY_ROUTE,
                },
                {
                  label: "Reports",
                  icon: <FaListAlt />,
                  subMenus: [
                    {
                      label: "Total meals served",
                      link: MEALS_ROUTES,
                    },
                    {
                      label: "Total revenue",
                      link: REVENUE_ROUTES,
                    },
                    {
                      label: "Top selling items",
                      link: TOP_SELLING_ROUTES,
                    },
                    {
                      label: "Employee satisfaction & Feedback Summary",
                      link: EMP_ROUTES,
                    },
                    {
                      label: "No of app usage",
                      link: EMP_USAGE_ROUTES,
                    },
                  ],
                },
              ]}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 bg-gray-50">
          {/* Header */}
          <div
            style={{ zIndex: 56 }}
            className="fixed top-0 left-0 right-[50px] flex items-center px-4 justify-between w-full h-[65px] max-h-[65px] bg-white shadow-sm border-b border-gray-200 backdrop-blur-sm"
          >
            <div className="flex items-center gap-6">
              <button
                onClick={toggleMobileSidebar}
                className="text-gray-600 hover:text-gray-800 hover:bg-gray-100 p-2 rounded-lg transition-all duration-200 md:opacity-0 md:pointer-events-none"
              >
                <FaBars className="text-xl" />
              </button>
              <Link
                to={DASHBOARD_ROUTE}
                className="flex items-center h-[60px] w-[150px] hover:opacity-90 transition-opacity"
              >
                <img
                  src="../../../assets/images/logo.jpg"
                  alt={siteName}
                  className="object-contain max-w-full max-h-full"
                />
              </Link>
            </div>

            <div className="flex items-center gap-2">
              <div ref={dropdownRef} className="relative dropdown-container">
                <div
                  className="inline-flex items-center overflow-hidden bg-white cursor-pointer hover:shadow-md transition-all duration-200 rounded-full border-2 border-transparent hover:border-blue-100"
                  onClick={toggleDropdown}
                >
                  <div className="flex items-center justify-center px-4 py-2 text-white rounded-full bg-gradient-to-br from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 w-10 h-10 font-semibold text-sm shadow-lg transition-all duration-200 hover:scale-105">
                    {"Avinash".slice(0, 1)}
                  </div>
                </div>

                {isDropdownOpen && (
                  <div
                    style={{ zIndex: 5000 }}
                    className="absolute right-0 mt-3 bg-white rounded-xl shadow-2xl border border-gray-200 w-56 overflow-hidden transform transition-all duration-200 ease-out animate-in slide-in-from-top-2"
                    role="menu"
                  >
                    <div className="px-4 py-4 bg-gradient-to-r from-blue-50 to-purple-50 border-b border-gray-100">
                      <div className="flex items-center space-x-3">
                        <div className="flex items-center justify-center w-12 h-12 text-white rounded-full bg-gradient-to-br from-blue-500 to-purple-600 font-semibold text-lg shadow-md">
                          {towerHeadAdminProfile?.name?.slice(0, 1)}
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-semibold text-gray-800 truncate">
                            {towerHeadAdminProfile?.name}
                          </p>
                          <p className="text-xs text-gray-500 truncate">
                            Corporate Admin Head
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="py-2">
                      <Link
                        to={PROFILE_ROUTE}
                        className="flex items-center w-full gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gradient-to-r hover:from-blue-50 hover:to-purple-50 hover:text-blue-700 transition-all duration-200 group"
                        role="menuitem"
                      >
                        <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-gray-100 group-hover:bg-blue-100 transition-colors duration-200">
                          <CgProfile className="text-gray-600 group-hover:text-blue-600" />
                        </div>
                        <div className="flex-1">
                          <p className="font-medium">My Profile</p>
                          <p className="text-xs text-gray-500">View and edit profile</p>
                        </div>
                      </Link>

                      <div className="h-px bg-gray-100 mx-2 my-2"></div>

                      <button
                        onClick={handleLogout}
                        className="flex items-center w-full gap-3 px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition-all duration-200 group"
                        role="menuitem"
                      >
                        <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-red-50 group-hover:bg-red-100 transition-colors duration-200">
                          <FaSignOutAlt className="text-red-500 group-hover:text-red-600" />
                        </div>
                        <div className="flex-1 text-left">
                          <p className="font-medium">Sign Out</p>
                          <p className="text-xs text-red-400">Logout from panel</p>
                        </div>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div
            style={{ height: `calc(100vh - 80px)` }}
            className="w-full px-3 pt-5 pb-10 mt-16 overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
          >
            {children}
          </div>
        </div>

        {isMobileSidebarOpen && (
          <div
            className="fixed inset-0 z-40 bg-black bg-opacity-30 backdrop-blur-sm md:hidden transition-all duration-300"
            onClick={toggleMobileSidebar}
          ></div>
        )}
      </div>
    </TowerAdminAuth>
  );
};

const MenuGroup = ({ label, menuItems, activeMenu, toggleSubMenu }) => {
  const location = useLocation();
  const isActive = (link) => location.pathname === link;
  const isSubMenuActive = (subMenus) => {
    return subMenus.some((subMenu) => isActive(subMenu.link));
  };

  return (
    <div className="mb-6">
      <h2 className="px-4 pt-3 pb-2 text-xs font-bold text-white uppercase bg-gradient-to-r from-gray-800 to-gray-700 tracking-wider">
        {label}
      </h2>
      <ul className="px-2 mt-2">
        {menuItems.map((item, index) => (
          <React.Fragment key={index}>
            {item.subMenus?.length > 0 ? (
              <li className="relative group mb-1">
                <div
                  className={`flex items-center justify-between py-3 px-3 text-gray-700 transition-all duration-200 rounded-lg cursor-pointer hover:bg-gradient-to-r hover:from-blue-50 hover:to-purple-50 hover:text-blue-700 hover:shadow-sm group ${isSubMenuActive(item.subMenus) ? 'bg-gradient-to-r from-blue-50 to-purple-50 text-blue-700 shadow-sm' : ''
                    }`}
                  onClick={() => toggleSubMenu(item.label)}
                >
                  <div className="flex items-center space-x-3">
                    <div className={`text-lg transition-colors duration-200 ${isSubMenuActive(item.subMenus) ? 'text-blue-600' : 'text-gray-500 group-hover:text-blue-600'
                      }`}>
                      {item.icon}
                    </div>
                    <span className="text-sm font-medium">{item.label}</span>
                  </div>
                  <div
                    className={`transition-all duration-300 ease-out ${activeMenu === item.label || isSubMenuActive(item.subMenus)
                      ? "rotate-180 text-blue-600"
                      : "rotate-0 text-gray-400"
                      }`}
                  >
                    <FaChevronDown className="text-xs" />
                  </div>
                </div>
                {(activeMenu === item.label || isSubMenuActive(item.subMenus)) && (
                  <ul className="pl-6 mt-2 space-y-1 border-l-2 border-blue-200 ml-6 animate-in slide-in-from-top-2 duration-200">
                    {item.subMenus.map((subMenu, subIndex) => {
                      return (
                        <Link to={subMenu.link} key={subIndex}>
                          <li
                            className={`py-2 px-3 text-sm rounded-lg transition-all duration-200 hover:bg-blue-50 hover:text-blue-700 ${isActive(subMenu.link)
                              ? "bg-blue-100 text-blue-700 font-medium shadow-sm"
                              : "text-gray-600"
                              }`}
                          >
                            {subMenu.label}
                          </li>
                        </Link>
                      );
                    })}
                  </ul>
                )}
              </li>
            ) : (
              <Link to={item.link}>
                <li className="relative group mb-1">
                  <div className={`flex items-center justify-between py-3 px-3 transition-all duration-200 rounded-lg cursor-pointer hover:bg-gradient-to-r hover:from-blue-50 hover:to-purple-50 hover:text-blue-700 hover:shadow-sm group ${isActive(item.link)
                    ? "bg-gradient-to-r from-blue-50 to-purple-50 text-blue-700 shadow-sm"
                    : "text-gray-700"
                    }`}>
                    <div className="flex items-center space-x-3">
                      <div className={`text-lg transition-colors duration-200 ${isActive(item.link) ? 'text-blue-600' : 'text-gray-500 group-hover:text-blue-600'
                        }`}>
                        {item.icon}
                      </div>
                      <span className="text-sm font-medium">{item.label}</span>
                    </div>
                    {isActive(item.link) && (
                      <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                    )}
                  </div>
                </li>
              </Link>
            )}
          </React.Fragment>
        ))}
      </ul>
    </div>
  );
};
export default Layout;
